export default "__VITE_ASSET__342a7d3e__"